import store from '@/store'

export function hasScope (scope) {
  // array or string
  if (!store.state.auth.user || !store.state.auth.user.role) {
    return false
  }
  const role = store.state.auth.user.role
  if (typeof scope === 'string') {
    return Boolean(role.scope.find(i => i.id === scope))
  } else if (Array.isArray(scope)) {
    for (var i in role.scope) {
      if (scope.includes(role.scope[i].id)) {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.js